import React from 'react';
import classNames from 'classnames';

export interface IconWrapperProps {
  LeftIcon?: React.ElementType<{ className?: string }>;
  RightIcon?: React.ElementType<{ className?: string }>;
  leftClassName?: string;
  rightClassName?: string;
  children?: React.ReactNode;
}

export const IconWrapper: React.FC<IconWrapperProps> = ({
  children,
  LeftIcon,
  RightIcon,
  leftClassName,
  rightClassName,
}) => {
  return (
    <div className={'relative rounded-md shadow-sm'}>
      {!!LeftIcon && (
        <div className={'pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'}>
          <LeftIcon className={classNames('h-5 w-5', leftClassName)} />
        </div>
      )}
      {children}
      {!!RightIcon && (
        <div className={'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'}>
          <RightIcon className={classNames('h-5 w-5', rightClassName)} />
        </div>
      )}
    </div>
  );
};
